import { API } from '@/config';
import moment from 'moment';
import Vue from 'vue';

class ExpiredProjectsService {
  #api = API;

  #store = Vue.observable({
    expiredProjectsList: [],
  });

  get expiredProjectsList() {
    return this.#store.expiredProjectsList;
  }

  async getAllProjectsListFromApi() {
    try {
      const params = {
        page: -1,
      };
      const result = (await this.#api.get('client/projects/getList', { params })).data.data.records;
      this.#store.expiredProjectsList = result.filter(project => this.getDaysToExpired(project.expired) < 14);
      this.saveProjectsInLocalStorage();
    } catch (error) {
      console.log(error);
    }
  }

  saveProjectsInLocalStorage() {
    const projectsListItem = {
      value: this.#store.expiredProjectsList,
      expiry: moment().valueOf() + 1000 * 60 * 60 * 12,
    };
    localStorage.setItem('projectsList', JSON.stringify(projectsListItem));
  }

  removeProjectsFromLocalStorage() {
    localStorage.removeItem('projectsList');
  }

  async getAllExpiredProjectsList() {
    const storagedProjectList = JSON.parse(localStorage.getItem('projectsList'));
    if (!storagedProjectList || moment().valueOf() > storagedProjectList.expiry) {
      await this.getAllProjectsListFromApi();
    }
    this.#store.expiredProjectsList = storagedProjectList?.value;
  }

  getDaysToExpired(expiredDate) {
    const currentDateWithoutTime = moment().startOf('day');
    const expiredDateWithoutTime = moment(expiredDate, 'YYYY-MM-DD');
    return moment.duration(expiredDateWithoutTime.diff(currentDateWithoutTime)).asDays();
  }
}

export default new ExpiredProjectsService();
